
export default "/assets/play-micro.00c24721.svg"